import React from 'react'
import svgPlus from 'assets/svg/icon-plus.svg'
import styled from 'styled-components'
import { getTheme, viewportWidth } from 'helpers'

export default styled.section`
  padding: 10px 0px;
  @media(max-width: 767px) {
    padding: 10px 0px 0px;
    border-top: 5px solid ${getTheme`colorBorder`};
  }
`
export const SectionHeader = styled.div`
  margin-bottom: 10px;
  position: relative;
  padding: 0px 10px;
`
export const SectionHeaderText = styled.div`
  @media(max-width: 767px) {
    display: inline-block;
    vertical-align: bottom;
    margin-right: 5px;
    font-size: 20px;
    line-height: 30px;
  }
  @media(min-width: 768px) {
    font-size: 26px;
    text-align: center;
  }
`
export const SectionHeaderCount = styled.div`
  line-height: 25px;
  color: ${getTheme`colorGray300`};
  @media(max-width: 767px) {
    display: inline-block;
    vertical-align: bottom;
    font-size: 14px;
  }
  @media(min-width: 768px) {
    font-size: 16px;
    text-align: center;
    margin-bottom: 20px;
  }
`
export const SectionBody = styled.div`
  @media(max-width: 767px) { padding: 0px 10px; }
`
export const SectionHeaderRight = styled.div`
  @media(max-width: 767px) {
    position: absolute;
    bottom: 0px;
    right: 10px;
    line-height: 25px;
  }
  @media(min-width: 768px) {
    display: none;
  }
`
export const BtnAdd = styled.div`
  color: ${getTheme`colorTiffany`};
  font-size: 16px;
  cursor: pointer;
  > img {
    width: 12px;
    height: 12px;
    margin-right: 5px;
  }
`
export const SectionFooter = styled.div`
  @media(max-width: 767px) {
    border-top: 1px solid ${getTheme`colorBorder`};
    border-bottom: 1px solid ${getTheme`colorBorder`};
    line-height: 40px;
    text-align: center;
  }
  @media(min-width: 768px) { display: none; }
`
export const IconRight = styled.img`
  vertical-align: top;
  height: 14px;
  margin-top: 13px;
  margin-left: 10px;
  filter: brightness(0) invert(0);
`
export const ItemWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  position: relative;
  cursor: pointer;
  &:hover { opacity: 0.8; }
  transition: opacity 0.3s ease;
  @media(min-width: 960px) {
    margin-right: 10px;
    width: calc(16.67% - 8.36px);
    &:nth-child(6n) {
      margin-right: 0px;
      ${props => !props.showAll && `
        &:after {
          pointer-events: none;
          content: 'ดูทั้งหมด \00000a ${props.count || ''} ${props.unit || ''}';
          white-space: pre-wrap;
          color: white;
          background-color: rgba(0, 0, 0, 0.8);
          position: absolute;
          top: 0px;
          left: 0px;
          right: 0px;
          bottom: 10px;
          z-index: 1;
          text-align: center;
          line-height: 30px;
          padding-top: calc(50% - 30px);
          cursor: pointer;
        }
        > div > div:nth-child(4) { display: none; }
        > div > div:nth-child(5) { display: none; }
        > div > div:nth-child(6) { display: none; }
      `}
    }
    ${props => !props.showAll && ' &:nth-child(n+7) { display: none; }'}
  }
  @media(min-width: 768px) and (max-width: 959px) {
    margin-right: 10px;
    width: calc(20% - 8px);
    &:nth-child(5) {
      margin-right: 0px;
      ${props => !props.showAll && `
        &:after {
          pointer-events: none;
          content: 'ดูทั้งหมด \00000a ${props.count || ''} ${props.unit || ''}';
          white-space: pre-wrap;
          color: white;
          background-color: rgba(0, 0, 0, 0.8);
          position: absolute;
          top: 0px;
          left: 0px;
          right: 0px;
          bottom: 10px;
          z-index: 1;
          text-align: center;
          line-height: 30px;
          padding-top: calc(50% - 30px);
          cursor: pointer;
        }
        > div > div:nth-child(4) { display: none; }
        > div > div:nth-child(5) { display: none; }
        > div > div:nth-child(6) { display: none; }
      `}
    }
    ${props => !props.showAll && '&:nth-child(n+6) { display: none; }'}
  }
  @media(min-width: 600px) and (max-width: 767px) {
    ${props => props.desktop && 'display: none;'}
    margin-right: 5px;
    width: calc(25% - 3.75px);
    &:nth-child(4n) { margin-right: 0px; }
  }
  @media(max-width: 599px) {
    ${props => props.desktop && 'display: none;'}
    margin-right: 5px;
    width: calc(33.33% - 4px);
    &:nth-child(3n) { margin-right: 0px; }
  }
`

export const BtnSquareAdd = ({ style, title, onClick, width }) =>
  <Wrapper style={style} onClick={onClick}>
    <IconPlus src={svgPlus} style={{ marginTop: (width - 70) / 2 }} />
    <Title style={{ paddingBottom: (width - 70) / 2 }}>{title}</Title>
  </Wrapper>

const Wrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  background-color: ${getTheme`colorBorder`};
  width: 100%;
  text-align: center;
  cursor: pointer;
  transition: opacity 0.3s ease;
  &:hover { opacity: 0.8; }
`
const IconPlus = styled.img`
  display: block;
  width: 40px;
  height: 40px;
  margin: 0 auto;
`
const Title = styled.div`
  margin-top: 10px;
  line-height: 20px;
`

export const colCount = () => {
  const vw = viewportWidth()
  if (vw > 960) return 6
  if (vw > 767) return 5
  if (vw > 414) return 4
  return 3
}
export const getContainerWidth = () => Math.min(viewportWidth(), 1080)
export const getItemWrapperWidth = (_width = viewportWidth()) => {
  const containerWidth = Math.min(_width, 1080)
  const sideMargin = (containerWidth > 767 ? 40 : 20)
  const betweenMargin = (colCount() - 1) * (containerWidth > 767 ? 10 : 5)
  return (containerWidth - sideMargin - betweenMargin) / colCount()
}



// WEBPACK FOOTER //
// ./src/components/profile/Section.js